import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';

import { SubSubGroupTypeCategoryDto } from '@cradua/data';
import { Observable } from 'rxjs/internal/Observable';
import {
  routeAnimations,
  ROUTE_ANIMATIONS_ELEMENTS,
} from 'libs/core/src/lib/animations';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';

@Component({
  selector: 'cradua-subsubgrouptypecategory-container',
  templateUrl: './subsubgrouptypecategory-container.component.html',
  styleUrls: ['./subsubgrouptypecategory-container.component.scss'],
})
export class SubsubgrouptypecategoryContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  subsubgrouptypecategorys$: Observable<SubSubGroupTypeCategoryDto[]>;
  loading: boolean;
  isLoadingSubSubGroupTypeCategory$: Observable<boolean>;
  constructor(private gatwayFacade: GatewayFacade) {}

  ngOnInit() {
    this.isLoadingSubSubGroupTypeCategory$ = this.gatwayFacade.isLoadingGateway(
      'SubSubGroupTypeCategory'
    );
    this.subsubgrouptypecategorys$ = this.gatwayFacade.loadGateway(
      'SubSubGroupTypeCategory'
    );
  }

  /**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteSubSubGroupTypeCategory(deletedValue: any) {
    this.gatwayFacade.remove('SubSubGroupTypeCategory', deletedValue);
  }

  // this method control both the create and update

  onSubmitSubSubGroupTypeCategory(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.SubSubGroupTypeCategorys;

    // declare two empty arrays to hold update and create data
    const allUpdates = [];
    const addAllSubSubGroupTypeCategory = [];

    // loop through the form data to check for update and create
    for (let i = 0; i < pullData.length; i++) {
      if (pullData[i].id !== null) {
        allUpdates.push(pullData[i]);
      } else {
        delete pullData[i].id;
        addAllSubSubGroupTypeCategory.push(pullData[i]);
      }
    }

    // check if the addAllSubSubGroupTypeCategory array is not empty, then dispatch the data to the store
    if (addAllSubSubGroupTypeCategory.length > 0) {
      this.gatwayFacade.add(
        'SubSubGroupTypeCategory',
        addAllSubSubGroupTypeCategory
      );
    }

    if (allUpdates.length > 0) {
      // dispatch update data to the store
      this.gatwayFacade.update('SubSubGroupTypeCategory', allUpdates, ['id']);
    }
  }
}
